import { createAsyncThunk } from '@reduxjs/toolkit';
import globalSearchAPI from '@infrastructure/global-search-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const globalSearchAsync = createAsyncThunk('globalSearch/search', async (body, { rejectWithValue }) => {
    try {
        const response = await globalSearchAPI.search(body);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
